<template>
  <div>
    <img
      :src="assets.image.middletonLogo"
      height="100"
      class="mb-3 mx-auto d-block"
      alt="Middleton Logo"
      v-if="currentSchool && currentSchool.SchoolName.toUpperCase().includes('MIDDLETON')"
    />
    <img :src="assets.image.eisLogo" height="100" class="mb-3 mx-auto d-block" alt="International School Logo" v-else-if="isInternationalSchool" />
    <img :src="assets.image.epsLogo" height="60" class="mb-3 mx-auto d-block" alt="PreSchool Logo" v-else />
  </div>
</template>
<script>
import assets from '@/assets/assets'

export default {
  name: 'WithdrawalFormLogo',
  props: ['currentSchool', 'isInternationalSchool'],
  data() {
    return {
      assets: assets,
    }
  },
  methods: {},
}
</script>
